<template>
  <div id="app">
    <h3>此頁面不存在</h3>
  </div>
</template>

<script>
/* eslint-disable */
import QRCode from 'qrcode'
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      content: 'https://www.eilis-ai.com/',
      options: {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        width: 200,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      }
    };
  },
  mounted() {
    // this.bindQRCode('https://liff.line.me/1653740000-3VJNOQAL?content=KLrbVB', this.$refs.qrCodeDiv);
    const element = this.$refs.QRCode;
    // QRCode.toCanvas(element, this.content, this.options, error => {
    //   if (error) {
    //     console.log(error);
    //   }
    //   else {
    //     console.log('generate success');
    //   }
    // })
  },
  methods: {
    // bindQRCode(url, chendom) {
    //   var qrCode = new QRCode(chendom, {
    //     width: 200, //二维码宽度,单位像素
    //     height: 200, //二维码高度,单位像素
    //     text: url, //二维码内容:二维码扫描之后访问的地址
    //     colorDark: "#000000", //前景色
    //     colorLight: "#ffffff", //背景色
    //     correctLevel: QRCode.CorrectLevel.H, //容错级别
    //   });
    // },
  }
}

</script>


<style>
  .loading {
    opacity: 1;
    transform: translateX(0%);
    transition: opacity .3s ease-in;
  }

  .ball {
    background-color: #777;
    border-radius: 50%;
    display: inline-block;
    margin: 5px;
    height: 10px;
    width: 10px;
    animation: jump .5s ease-in infinite;
  }
  .app {
    text-align: center;
  }

  .ball:nth-of-type(2) {
    animation-delay: 0.1s;
  }

  .ball:nth-of-type(3) {
    animation-delay: 0.2s;
  }

  @keyframes jump {
    0%, 100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-10px);
    }
  }
</style>
